<template>

    <div class="mx-sm-1 mt-9">
        <div class="page-header">
            <h1 class="page-title fw-bold">Nouveaux besoins</h1>
            <div>
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><router-link :to="{ name: 'dashboard' }"><a>Tableau de
                                bord</a></router-link></li>
                    <li class="breadcrumb-item active" aria-current="page"><router-link
                            :to="{ name: 'nouveauBesoin' }"><a>Nouveaux besoins </a></router-link></li>
                </ol>
            </div>
        </div>
        <div class="my-2">
            <router-link :to="{ name: 'pta',params: {  annee:anneeRoute } }"><a><i class="fe fe-arrow-left"></i>
                    Retour</a></router-link>
        </div>
        <div class="row">
            <div class="col-12 col-sm-12" v-if="showList">
                <div class="modal fade" v-if="activite" id="genrationPta" tabindex="-1" role="dialog">
                    <div class="modal-dialog modal-fullscreen modal-dialog-scrollable" role="document">
                        <div class="modal-content">
                            <div class="modal-header bg-primary text-white">
                                <h6 class="modal-title fw-bold" style="font-size: 16px;">Détail du PTA de l'activite :
                                    {{
                                        activite.nomDetail }}</h6>
                                <button aria-label="Close" class="btn-close text-white" data-bs-dismiss="modal"
                                    type="button"><span aria-hidden="true">×</span></button>
                            </div>
                            <div class="modal-body">
                                <div class="table-responsive">
                                    <div class="form-group d-flex justify-content-between mt-5 me-3">
                                        <p class="fw-bold">AE = Autorisation de programme ; CP = Crédit de paiment ; BN
                                            =
                                            Budget national ANT=xxx BA=xxxx </p>

                                        <button @click="mettreZero" type="button" :disabled="grisertout == true"
                                            class="style_btn btn btn-outline-info rounded-0 me-2">
                                            Remettre à O
                                        </button>

                                    </div>
                                    <p class="text-end">(En miliers de FCFA TTC)</p>

                                    <table id="data-table"
                                        class="table table-responsive table-hover table-bordered text-nowrap mb-0">
                                        <thead class="border-top danger02">
                                            <tr>
                                                <th class="fw-bold">ID PTA</th>
                                                <th class="fw-bold">Année</th>
                                                <th class="fw-bold">Date Début</th>
                                                <th class="fw-bold">Date Fin</th>
                                                <th class="fw-bold">Description</th>
                                                <th class="fw-bold">Report</th>
                                                <th class="fw-bold text-center">AE BESOIN <br> - BN</th>
                                                <th class="fw-bold text-center">AE BESOIN <br> - Pret</th>
                                                <th class="fw-bold text-center">AE BESOIN <br> - Don</th>
                                                <th class="fw-bold text-center">AE BESOIN <br> - ANT</th>
                                                <th class="fw-bold text-center">AE BESOIN <br> - BA</th>
                                                <th class="fw-bold text-center" style="background-color: cadetblue;">AE
                                                    BESOIN <br>- TOTAL</th>
                                                <th class="fw-bold text-center">CP BESOIN <br> - BN </th>
                                                <th class="fw-bold text-center">CP BESOIN <br> - Pret</th>
                                                <th class="fw-bold text-center">CP BESOIN <br> - Don</th>
                                                <th class="fw-bold text-center">CP BESOIN <br> - ANT</th>
                                                <th class="fw-bold text-center">CP BESOIN <br> - BA</th>
                                                <th class="fw-bold text-center" style="background-color: cadetblue;">CP
                                                    BESOIN <br>- Total</th>

                                            </tr>
                                        </thead>
                                        <tfoot>
                                            <tr>
                                                <td colspan="5" class="fw-bold text-end">Totaux</td>
                                                <td>{{ totaux.reportMobiliseTot.toLocaleString('fr-FR')  }}</td>
                                                <td>{{ totaux.aeBn.toLocaleString('fr-FR')  }}</td>
                                                <td>{{ totaux.aePret.toLocaleString('fr-FR')  }}</td>
                                                <td>{{ totaux.aeDon.toLocaleString('fr-FR')  }}</td>
                                                <td>{{ totaux.aeAnt.toLocaleString('fr-FR')  }}</td>
                                                <td>{{ totaux.aeBa.toLocaleString('fr-FR')  }}</td>
                                                <td style="background-color: cadetblue;">{{ totaux.aeTotal.toLocaleString('fr-FR')  }}</td>
                                                <td>{{ totaux.cpBn.toLocaleString('fr-FR')  }}</td>
                                                <td>{{ totaux.cpPret.toLocaleString('fr-FR')  }}</td>
                                                <td>{{ totaux.cpDon.toLocaleString('fr-FR')  }}</td>
                                                <td>{{ totaux.cpAnt.toLocaleString('fr-FR')  }}</td>
                                                <td>{{ totaux.cpBa.toLocaleString('fr-FR')  }}</td>
                                                <td style="background-color: cadetblue;">{{ totaux.cpTotal.toLocaleString('fr-FR')  }}</td>
                                            </tr>
                                        </tfoot>

                                        <tbody v-if="ptas.length > 0" id="myTable1">
                                            <tr v-for="pta in ptas" :key="pta.key"
                                                :class="{ 'table-danger': isEmpty(pta.value) }">
                                                <td>
                                                    {{ pta?.idPtaAsin }}
                                                </td>
                                                <td>
                                                    {{ pta.annee.annee }}
                                                </td>
                                                <td>
                                                    {{ formatDate(pta.dateDebut) }}
                                                </td>
                                                <td>
                                                    {{ formatDate(pta.dateFin) }}
                                                </td>
                                                <td>
                                                    {{ pta.description }}
                                                </td>
                                                 <td>
                                                    {{ pta.reportMobiliseTot.toLocaleString('fr-FR')  }}
                                                </td>
                                                <td>
                                                    <input type="number" :disabled="grisertout == true"
                                                        class="form-control border-dark" v-model="pta.besoinAeBnTtc">
                                                </td>
                                                <td>
                                                    <input type="number" :disabled="grisertout == true"
                                                        class="form-control border-dark" v-model="pta.besoinAePretTtc">

                                                </td>
                                                <td>
                                                    <input type="number" :disabled="grisertout == true"
                                                        class="form-control border-dark" v-model="pta.besoinAeDonTtc">

                                                </td>
                                                <td>
                                                    <input type="number" :disabled="grisertout == true"
                                                        class="form-control border-dark" v-model="pta.besoinAeAntTtc">

                                                </td>
                                                <td>
                                                    <input type="number" :disabled="grisertout == true"
                                                        class="form-control border-dark" v-model="pta.besoinAeBaTtc">

                                                </td>
                                                <td :style="{ backgroundColor: 'cadetblue' }">
                                                    {{ payload.besoinAeTotal = calculerBesoinAeTotal(pta) }}
                                                </td>
                                                <td>
                                                    <input type="number" :disabled="grisertout == true"
                                                        class="form-control border-dark" v-model="pta.besoinCpBnTtc">

                                                </td>
                                                <td>
                                                    <input type="number" :disabled="grisertout == true"
                                                        class="form-control border-dark" v-model="pta.besoinCpPretTtc">

                                                </td>
                                                <td>
                                                    <input type="number" :disabled="grisertout == true"
                                                        class="form-control border-dark" v-model="pta.besoinCpDonTtc">

                                                </td>
                                                <td>
                                                    <input type="number" :disabled="grisertout == true"
                                                        class="form-control border-dark" v-model="pta.besoinCpAntTtc">

                                                </td>

                                                <td>
                                                    <input type="number" :disabled="grisertout == true"
                                                        class="form-control border-dark" v-model="pta.besoinCpBaTtc">

                                                </td>
                                                <td :style="{ backgroundColor: 'cadetblue' }">
                                                    {{ payload.besoinCpTotal = calculerBesoinCpTotal(pta) }}
                                                </td>
                                            </tr>
                                        </tbody>

                                        <tbody v-else>
                                            <tr class="primary02">
                                                <td colspan="18" class="text-center">Aucune composante trouvée</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div class="form-group d-flex justify-content-end mt-5 me-3">

                                        <button @click="sauvegarder(activite)" type="button"
                                            :disabled="grisertout == true"
                                            class="style_btn btn btn-outline-success rounded-0">
                                            Sauvegarder la saisie
                                        </button>
                                    </div>

                                </div>
                            </div>
                            <div class="modal-footer">
                                <button class="btn btn-gray" data-bs-dismiss="modal">Fermer</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal fade" id="detail-composante" tabindex="-1" role="dialog">
                    <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                        <div class="modal-content">
                            <div class="modal-header bg-primary text-white">
                                <h6 class="modal-title fw-bold" style="font-size: 16px;">Détail de la ligne séléctionnée
                                </h6>
                                <button aria-label="Close" class="btn-close text-white" data-bs-dismiss="modal"
                                    type="button"><span aria-hidden="true">×</span></button>
                            </div>
                            <div class="modal-body">
                                <table id="data-table" class="table  table-hover table-bordered text-nowrap mb-0">
                                    <thead class="border-top danger02">
                                        <tr>
                                            <th class="fw-bold">Type</th>
                                            <th class="fw-bold">Description</th>
                                            <th class="fw-bold">Date Début</th>
                                            <th class="fw-bold">Date Fin</th>
                                            <th class="fw-bold">Statut</th>
                                            <th class="fw-bold">% Executé</th>

                                        </tr>
                                    </thead>
                                    <tbody v-if="lestaches.length > 0" id="myTable1">
                                        <tr v-for="tache in lestaches" :key="tache.key"
                                            :class="{ 'table-danger': isEmpty(tache.value) }">
                                            <td>
                                                {{ tache.nomDetail }}
                                            </td>
                                            <td>
                                                {{ tache.notes }}
                                            </td>
                                            <td>
                                                {{ formatDate(tache.dateDebut) }}
                                            </td>
                                            <td>
                                                {{ formatDate(tache.dateFin) }}
                                            </td>
                                            <td>
                                                <span
                                                    :class="tache.statut === 'EN COURS' ? 'badge bg-secondary' : 'badge bg-warning'">
                                                    {{ tache.statut }}
                                                </span>

                                            </td>
                                            <td>
                                                {{ tache.pctExecute }} %
                                            </td>

                                        </tr>
                                    </tbody>
                                    <tbody v-else>
                                        <tr class="primary02">
                                            <td colspan="6" class="text-center">Aucune composante trouvée</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="modal-footer">
                                <button class="btn btn-gray" data-bs-dismiss="modal">Fermer</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label class="form-label">Année <span class="text-danger">*</span></label>
                                    <multi-select deselect-label="Sélectionné" select-label="" :options="exercices"
                                        @select="selectAnnee" placeholder="Sélectionné " label="annee" track-by="annee"
                                        :searchable="true" :custom-label="o => o.annee" v-model="payload.exercice">
                                        <template slot="singleLabel" slot-scope="{ option }">
                                            <strong> {{ option.annee }}</strong>
                                        </template>
                                        <span slot="noOptions">
                                            <strong>Liste Vide</strong>
                                        </span>
                                        <span slot="noResult">
                                            <strong>Aucun Résultat</strong>
                                        </span>
                                    </multi-select>

                                </div>
                            </div>
                            <div class="col-md-5" v-if="choixClasseur">
                                <div class="form-group">
                                    <label class="form-label">Classeur <span class="text-danger">*</span></label>
                                    <multi-select deselect-label="Sélectionné" select-label="" :options="classeurs"
                                        @select="chargerComposantes" placeholder="Sélectionné un classeur"
                                        label="nomClasseur" track-by="idClasseur" :searchable="true"
                                        :custom-label="o => o.idClasseur + ' - ' + o.nomClasseur"
                                        v-model="payload.classeur">
                                        <template slot="singleLabel" slot-scope="{ option }">
                                            <strong> {{ option.nomClasseur }}</strong>
                                        </template>
                                        <span slot="noOptions">
                                            <strong>Liste Vide</strong>
                                        </span>
                                        <span slot="noResult">
                                            <strong>Aucun Résultat</strong>
                                        </span>
                                    </multi-select>

                                </div>
                            </div>

                            <div class="col-md-5" v-if="choixComposanteaffiche">
                                <div class="form-group">
                                    <label class="form-label">Composantes <span class="text-danger">*</span></label>
                                    <multi-select deselect-label="Sélectionné" select-label="" :options="composantes"
                                        @select="choixComposantes" placeholder="Sélectionné un composant"
                                        label="nomClasseur" track-by="idComposante" :searchable="true"
                                        :custom-label="o => o.idComposante + ' - ' + o.nomComposante"
                                        v-model="payload.composante">
                                        <template slot="singleLabel" slot-scope="{ option }">
                                            <strong> {{ option.nomComposante }}</strong>
                                        </template>
                                        <span slot="noOptions">
                                            <strong>Liste Vide</strong>
                                        </span>
                                        <span slot="noResult">
                                            <strong>Aucun Résultat</strong>
                                        </span>
                                    </multi-select>


                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="choixCompo">
                            <div class="row h-100">
                                <div class="col-md-2">
                                    <div class="card h-100">
                                        <div class="card-body alert alert-secondary shadow shadow">

                                            <p class="card-text fw-bold">
                                                <i class="fe fe-tag fs-18"></i>{{ payload.composante?.imputation ?
                                                    payload.composante?.imputation : '---' }}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-3 ">
                                    <div class="card h-100">
                                        <div class="card-body alert alert-secondary shadow shadow">

                                            <p class="card-text fw-bold">
                                                <i class="fe fe-tag fs-18"></i>{{ payload.composante?.pmoReferent?.nom
                                                }}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-3 ">
                                    <div class="card h-100">
                                        <div class="card-body alert alert-secondary shadow shadow">

                                            <p class="card-text fw-bold">
                                                <i class="fe fe-tag fs-18"></i>{{ payload.composante?.chefProjet?.nom }}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-2">
                                    <div class="card h-100">
                                        <div class="card-body alert alert-secondary shadow shadow">

                                            <p class="card-text fw-bold">
                                                <i class="fe fe-tag fs-18"></i>{{
                                                    formatDate(payload.composante.dateFinPlanifiee) }}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-2">
                                    <div class="card h-100">
                                        <div class="card-body alert alert-secondary shadow shadow">

                                            <p class="card-text fw-bold">
                                                <i class="fe fe-tag fs-18"></i>{{
                                                    formatDate(payload.composante?.dateDebutPlanifiee) }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <hr>
                        <div class="row" v-if="choixAnnee">
                            <h4 class="fw-bold">Liste des activités éligibles au PTA</h4>
                            <p class="text-end">(En miliers de FCFA TTC)</p>
                            <div class="table-responsive">

                                <table id="data-table" class="table table-hover table-bordered text-nowrap mb-0">
                                    <thead class="border-top danger02">
                                        <tr>
                                            <th class="fw-bold">Action</th>
                                            <th class="fw-bold">Id Pta</th>
                                            <th class="fw-bold">Type</th>
                                            <th class="fw-bold">Description</th>
                                            <th class="fw-bold">Date Début</th>
                                            <th class="fw-bold">Date Fin</th>
                                            <th class="fw-bold">Statut</th>
                                            <th class="fw-bold">% Executé</th>
                                            <th class="fw-bold">% Taux CP/AE</th>
                                            <th class="fw-bold">Report</th>
                                            <th class="fw-bold text-center">AE BESOIN <br> - BN</th>
                                            <th class="fw-bold text-center">AE BESOIN <br> - Pret</th>
                                            <th class="fw-bold text-center">AE BESOIN <br> - Don</th>
                                            <th class="fw-bold text-center">AE BESOIN <br> - ANT</th>
                                            <th class="fw-bold text-center">AE BESOIN <br> - BA</th>
                                            <th class="fw-bold text-center" style="background-color: cadetblue;">AE
                                                BESOIN <br>- TOTAL</th>
                                            <th class="fw-bold text-center">CP BESOIN <br> - BN </th>
                                            <th class="fw-bold text-center">CP BESOIN <br> - Pret</th>
                                            <th class="fw-bold text-center">CP BESOIN <br> - Don</th>
                                            <th class="fw-bold text-center">CP BESOIN <br> - ANT</th>
                                            <th class="fw-bold text-center">CP BESOIN <br> - BA</th>
                                            <th class="fw-bold text-center" style="background-color: cadetblue;">CP
                                                BESOIN <br>- Total</th>

                                        </tr>
                                    </thead>
                                    <tbody v-if="lesactivites.length > 0" id="myTable1">
                                        <tr v-for="activite in lesactivites" :key="activite.key"
                                            :class="{ 'table-danger': isEmpty(activite.value) }">
                                            <td>
                                                <button class="btn text-primary btn-sm"
                                                    @click="genrationPtaModal(activite)" data-bs-toggle="tooltip"
                                                    title="Modifier" data-bs-original-title="Modifier"><span
                                                        class="fe fe-edit fs-18"></span></button>
                                                <button class="modal-effect btn text-warning btn-sm"
                                                    @click="showDetail(activite)" title="Voir le détail"
                                                    data-bs-original-title="Voir le détail"
                                                    data-bs-effect="effect-scale" data-bs-toggle="modal">
                                                    <span class="fe fe-eye fs-18"></span></button>
                                            </td>
                                            <td>
                                                {{ activite?.pta?.idPtaAsin ? activite?.pta?.idPtaAsin : '' }}
                                            </td>
                                            <td>
                                                {{ activite.nomDetail }}
                                            </td>
                                            <td>
                                                {{ activite.notes }}
                                            </td>
                                            <td>
                                                {{ formatDate(activite?.dateDebut) }}
                                            </td>
                                            <td>
                                                {{ formatDate(activite?.dateFin) }}
                                            </td>
                                            <td>
                                                <span
                                                    :class="activite.statut === 'EN COURS' ? 'badge bg-secondary' : 'badge bg-warning'">
                                                    {{ activite.statut }}
                                                </span>

                                            </td>
                                            <td>
                                                {{ activite.pctExecute }} %
                                            </td>

                                            <td>
                                                {{ activite?.pta?.pctAeCp }} %
                                            </td>
                                            <td>
                                                {{ activite?.pta?.reportMobiliseTot.toLocaleString('fr-FR') }}

                                            </td>

                                            <td>
                                                {{ activite?.pta?.besoinAeBnTtc.toLocaleString('fr-FR') }}

                                            </td>
                                            <td>
                                                {{ activite?.pta?.besoinAePretTtc?.toLocaleString('fr-FR') }}

                                            </td>
                                            <td>

                                                {{ activite?.pta?.besoinAeDonTtc?.toLocaleString('fr-FR') }}


                                            </td>
                                            <td>
                                                {{ activite?.pta?.besoinAeAntTtc?.toLocaleString('fr-FR') }}


                                            </td>
                                            <td>
                                                {{ activite?.pta?.besoinAeBaTtc?.toLocaleString('fr-FR') }}


                                            </td>
                                            <td :style="{ backgroundColor: 'cadetblue' }">

                                                {{ activite?.pta?.besoinAeTotTtc?.toLocaleString('fr-FR') }}

                                            </td>
                                            <td>

                                                {{ activite?.pta?.besoinCpBnTtc?.toLocaleString('fr-FR') }}


                                            </td>
                                            <td>
                                                {{ activite?.pta?.besoinCpPretTtc?.toLocaleString('fr-FR') }}


                                            </td>
                                            <td>
                                                {{ activite?.pta?.besoinCpDonTtc?.toLocaleString('fr-FR') }}


                                            </td>
                                            <td>
                                                {{ activite?.pta?.besoinCpAntTtc?.toLocaleString('fr-FR') }}


                                            </td>

                                            <td>
                                                {{ activite?.pta?.besoinCpBaTtc?.toLocaleString('fr-FR') }}


                                            </td>
                                            <td :style="{ backgroundColor: 'cadetblue' }">
                                                {{ activite?.pta?.besoinCpTotTtc?.toLocaleString('fr-FR') }}

                                            </td>

                                        </tr>
                                    </tbody>
                                    <tbody v-else>
                                        <tr class="primary02">
                                            <td colspan="21" class="text-center">Aucune composante trouvée</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                        </div>


                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
//import $ from 'jquery';
import { mapGetters, mapActions } from 'vuex';
import * as lang from "vuejs-datepicker/src/locale";
import Composantes from './GenerationPta.vue';
export default {
    name: "GenerationPta",
    data() {
        return {anneeRoute:'',
            lang: lang, payload: { currentStep: 1, classeur: null, composante: "" }, pta: { annee: "", dateDebut: "", dateFin: "", description: "", besoinAeBnTtc: 0, besoinAePretTtc: 0, besoinAeDonTtc: 0, besoinAeAntTtc: 0, besoinAeBaTtc: 0, besoinAeTotTtc: 0, besoin_cp_bn_ttc: 0, besoinCpPretTtc: 0, besoinCpDonTtc: 0, besoinCpAntTtc: 0, besoinCpBaTtc: 0, besoinCpTotTtc: 0 },
            save: true, showList: true, notModified: false, choixCompo: false, choixAnnee: false, choixClasseur: false, choixComposanteaffiche: false,
            classeurs: [], composantes: [], exercices: [], typologies: [], lesactivites: [], lestaches: [], ptas: [], activite: null, grisertout: false
        }
    },
    computed: {
        ...mapGetters({ items: 'generationPta' }),
        filtersItems() {
            return this.items || [];
        },
        fr() {
            return this.lang.fr;
        },
        activeStep() {
            return this.steps[this.payload.currentStep - 1];
        },
        isLastStep() {
            return this.payload.currentStep === this.steps.length;
        },
        totaux() {
            const total = {
                aeBn: 0,
                aePret: 0,
                aeDon: 0,
                aeAnt: 0,
                aeBa: 0,
                aeTotal: 0,
                reportMobiliseTot : 0,

                cpBn: 0,
                cpPret: 0,
                cpDon: 0,
                cpAnt: 0,
                cpBa: 0,
                cpTotal: 0,
            };

            this.ptas.forEach(pta => {
                total.aeBn += Number(pta.besoinAeBnTtc) || 0;
                total.aePret += Number(pta.besoinAePretTtc) || 0;
                total.aeDon += Number(pta.besoinAeDonTtc) || 0;
                total.aeAnt += Number(pta.besoinAeAntTtc) || 0;
                total.aeBa += Number(pta.besoinAeBaTtc) || 0;
                total.reportMobiliseTot += Number(pta.reportMobiliseTot) || 0;

                total.aeTotal += this.calculerBesoinAeTotal(pta);

                total.cpBn += Number(pta.besoinCpBnTtc) || 0;
                total.cpPret += Number(pta.besoinCpPretTtc) || 0;
                total.cpDon += Number(pta.besoinCpDonTtc) || 0;
                total.cpAnt += Number(pta.besoinCpAntTtc) || 0;
                total.cpBa += Number(pta.besoinCpBaTtc) || 0;
                total.cpTotal += this.calculerBesoinCpTotal(pta);
            });

            return total;
        }

    },
    watch: {
        imported: {
            immediate: true,
            handler(val) {
                if (val) this.payload.currentStep++;
            },
        },
    },
    mounted() {
    },
    methods: {
        ...mapActions('generationPta', ['all', 'add']),
        isEmpty(value) {
            return value === null || value === '' || (typeof value === 'object' && Object.keys(value).length === 0);
        },
        onSearch(offset) {
            this.$loading(true);
            if (offset > 0) this.option.page = offset - 1;
            this.$router.push({ query: this.option }).catch(() => { });
            this.getExercices();
            this.getClasseurs();
            //    this.getComposantes();
        },
        calculerBesoinAeTotal(pta) {
            this.payload.besoinAeTotal = Number(pta.besoinAeBnTtc) +
                Number(pta.besoinAePretTtc) +
                Number(pta.besoinAeDonTtc) +
                Number(pta.besoinAeAntTtc) +
                Number(pta.besoinAeBaTtc);
            return (
                this.payload.besoinAeTotal
            );
        },
        calculerBesoinCpTotal(pta) {
            this.pta.besoinCpTotal = Number(pta.besoinCpBnTtc) + Number(pta.besoinCpPretTtc) + Number(pta.besoinCpDonTtc) +
                Number(pta.besoinCpAntTtc) +
                Number(pta.besoinCpBaTtc);

            return (
                this.pta.besoinCpTotal
            );
        },
        async sauvegarder(activite) {
            $('#genrationPta').modal('hide');
            this.$loading(true);

            this.ptas.forEach(pta => {
                pta.besoinAeTotTtc =
                    Number(pta.besoinAeBnTtc) +
                    Number(pta.besoinAePretTtc) +
                    Number(pta.besoinAeDonTtc) +
                    Number(pta.besoinAeAntTtc) +
                    Number(pta.besoinAeBaTtc);

                pta.besoinCpTotTtc =
                    Number(pta.besoinCpBnTtc) +
                    Number(pta.besoinCpPretTtc) +
                    Number(pta.besoinCpDonTtc) +
                    Number(pta.besoinCpAntTtc) +
                    Number(pta.besoinCpBaTtc);

                pta.pctAeCp = ((pta.besoinCpTotTtc / pta.besoinAeTotTtc) * 100);
            });

            try {
                const { data } = await this.$http.put('/pta/list/' + activite.id, this.ptas);

                this.activite = null;

                this.mettreZero();
                await this.choixComposantes();

                await swal('Information!', 'Sauvegarde effectuée avec succès.', 'success');
            } catch (error) {
                swal('Erreur', 'Une erreur est survenue lors de la sauvegarde: ' + error, 'warning');
            } finally {
                this.$loading(false);
            }
        }
        ,
        cadrage() {
            console.log(this.ptas);
        },
        mettreZero() {
            console.log(this.ptas);
            this.ptas.forEach(pta => {
                pta.besoinAeBnTtc = 0;
                pta.besoinAePretTtc = 0;
                pta.besoinAeDonTtc = 0;
                pta.besoinAeAntTtc = 0;
                pta.besoinAeBaTtc = 0;
                pta.besoinAeTotTtc = 0;
                pta.besoinCpBnTtc = 0;
                pta.besoinCpPretTtc = 0;
                pta.besoinCpDonTtc = 0;
                pta.besoinCpAntTtc = 0;
                pta.besoinCpBaTtc = 0;
                pta.besoinCpTotTtc = 0;
            });

            console.log(this.ptas);
        },
        selectAnnee() {
            this.choixClasseur = true;
            if (this.payload.exercice.annee && this.payload.composante.idComposante) {

                // this.choixCompo = true;
                this.$loading(true);
                console.log('Composante sélectionné :', this.payload.composante);
                this.$http.get(`/detailsComposantes/2/${this.payload.exercice.annee}/${this.payload.composante.idComposante}`)
                    .then(({ data }) => {
                        console.log(data);
                        console.log(22);
                        this.lesactivites = data;
                        this.choixAnnee = true;
                        this.$loading(false);
                    });
            }
        },
        choixComposantes() {
            if (!this.payload.composante || !this.payload.composante.idComposante) {
                console.warn('Composantes non sélectionné ou invalide');
                return;
            }
            this.choixCompo = true;
            this.$loading(true);
            console.log('Composante sélectionné :', this.payload.composante);
            this.$http.get(`/detailsComposantes/2/${this.payload.exercice.annee}/${this.payload.composante.idComposante}`)
                .then(({ data }) => {
                    console.log(data);
                    console.log(22);
                    this.lesactivites = data;
                    this.choixAnnee = true;
                    this.$loading(false);
                });
            // this.chargerActivite();
        },
        async choixComposantes() {
            if (!this.payload.composante || !this.payload.composante.idComposante) {
                console.warn('Composantes non sélectionné ou invalide');
                return;
            }

            this.choixCompo = true;
            this.$loading(true);

            try {
                console.log('Composante sélectionnée :', this.payload.composante);

                const response = await this.$http.get(
                    `/detailsComposantes/2/${this.payload.exercice.annee}/${this.payload.composante.idComposante}`
                );

                console.log(response.data);
                console.log(22);

                this.lesactivites = response.data;
                this.choixAnnee = true;

            } catch (error) {
                console.error('Erreur lors du chargement des activités :', error);
            } finally {
                this.$loading(false);
            }
        }
        ,

        chargerComposantes() {
            // Vérification de l'objet sélectionné
            this.choixComposanteaffiche = true;
            if (!this.payload.classeur || !this.payload.classeur.idClasseur) {
                console.warn('Classeur non sélectionné ou invalide');
                return;
            }
            console.log('Classeur sélectionné :', this.payload.classeur);
            this.$loading(true);

            this.$http
                .get(`/composantes/classeursListe/${this.payload.classeur.idClasseur}`)
                .then(({ data }) => {
                    this.composantes = data;
                    console.log('Composantes reçues :', data);
                    this.choixCompo = false;
                    this.choixAnnee = false;
                    this.payload.composante = null;

                })
                .catch((error) => {
                    console.error('Erreur lors du chargement des composantes :', error);
                })
                .finally(() => {
                    this.$loading(false);
                });
        }
        ,
        getClasseurs() {
            this.$http.get('/classeurs/all')
                .then(({ data }) => {
                    console.log(data);
                    console.log(1);
                    this.classeurs = data;
                    this.$loading(false);
                });


        },

        getExercices() {
            this.$http.get('/exercice')
                .then(({ data }) => {
                    console.log(data);
                    console.log(1);
                    this.exercices = data;

                });
        },

        getComposantes() {
            this.$http.get('/composantes')
                .then(({ data }) => {
                    console.log(data);
                    console.log(22);
                    this.composantes = data;
                    this.$loading(false);
                });
        },
        chargerActivite() {
            this.$loading(true);
            this.$http.get(`/detailsComposantes/2/${this.payload.exercice.annee}/${this.payload.composante.idComposante}`)
                .then(({ data }) => {
                    console.log(data);
                    console.log(22);
                    this.lesactivites = data;
                    this.choixAnnee = true;
                    this.$loading(false);
                });
        }
        , showDetail(item) {
            this.$loading(true);
            this.$http.get(`/detailsComposantes/taskGuid/${item.taskGuid}`)
                .then(({ data }) => {
                    console.log(data);
                    this.lestaches = data;
                    this.$loading(false);
                    $('#detail-composante').modal('show');
                });


        },
        genrationPtaModal(item) {
            this.grisertout = false;
            console.log(11111111111111)
            console.log(item)
            this.$loading(true);

            this.activite = item;
            this.grisertout = item?.pta?.statutValidation?.idStatutValidation == "VAL001" ? true : false;
            this.$http.get(`/pta/parent/all/${item.id}`)
                .then(({ data }) => {
                    this.ptas = data
                    console.log(data);
                    if (this.ptas.length > 0) {

                        $('#genrationPta').modal('show');
                        this.$loading(false);
                    }
                    else {
                        const annees = this.exercices.find(a => a.annee == item.annee);
                        this.pta = {
                            id: 0,
                            annee: annees,
                            idDetail: item,
                            sourceFinancement: { sourceFinancement: "A confirmer" },
                            typologie: { typologie: "NON CADRÉ" },
                            idPtaAsin: null,
                            idPtaSecteur: null,
                            description: item.nomDetail,
                            dateDebut: item.dateDebut,
                            dateFin: item.dateFin,
                            dureeJours: 0,
                            prioriteAsin: null,
                            imputationBud: this.payload.composante.imputation,
                            pmoReferent: this.payload.composante.pmoReferent.nom,
                            chefPrjAsin: this.payload.composante.chefProjet.nom,
                            direction: null,
                            descriptionPrec: null,
                            aePrec: 0,
                            cpPrec: 0,
                            besoinAeBnTtc: 0,
                            besoinAePretTtc: 0,
                            besoinAeDonTtc: 0,
                            besoinAeAntTtc: 0,
                            besoinAeBaTtc: 0,
                            besoinAeTotTtc: 0,
                            besoinCpBnTtc: 0,
                            besoinCpPretTtc: 0,
                            besoinCpDonTtc: 0,
                            besoinCpAntTtc: 0,
                            besoinCpBaTtc: 0,
                            besoinCpTotTtc: 0,
                            pctAeCp: 0,
                            reportBnTtc: 0,
                            reportPretTtc: 0,
                            reportDonTtc: 0,
                            reportAntTtc: 0,
                            reportBaTtc: 0,
                            reportMobiliseTot: 0,
                            alloueAeBnTtc: 0,
                            alloueAePretTtc: 0,
                            alloueAeDonTtc: 0,
                            alloueAeAnTtc: 0,
                            alloueAeBaTtc: 0,
                            alloueAeTotTtc: 0,
                            alloueCpBnTtc: 0,
                            alloueCpPretTtc: 0,
                            alloueCpDonTtc: 0,
                            alloueCpAnTtc: 0,
                            alloueCpBaTtc: 0,
                            alloueCpTotTtc: 0,
                            idDetailParent: 0,
                            idPtaAsinPrec: null,
                            typologieInvest: null,
                            poids: 0,
                            categorie: null,
                            recurrent: null,
                            contratCadre: null,
                            missionTerrainPmo: null,
                            tacheCom: null,
                            methodMarche: null,
                            dureeEstimMarche: 0,
                            // datePrevuLancement: new Date().toISOString(),
                            // dateLanceAuplustard: new Date().toISOString(),
                            // datePrevueContrat: new Date().toISOString()
                        };
                        console.log(this.pta)


                        this.$http.post('/pta', this.pta)
                            .then(({ data }) => {
                                console.log(data);
                                this.$http.get(`/pta/parent/all/${item.id}`)
                                    .then(({ data }) => {


                                        this.ptas = data
                                        $('#genrationPta').modal('show');
                                        this.$loading(false);
                                    })

                            })
                            .catch((error) => {
                                swal('Information!', 'Une erreur est survenue lors de l\'enregistrement. ' + error, 'warning');
                            })
                            .finally(() => this.$loading(false));
                    }

                });
        },
        hideModal1() {
            $('#detail-composante').modal('hide');
        },

        showForm() {
            this.showList = false;
        },
        formatDate(dateStr) {
            const date = new Date(dateStr);
            return date.toLocaleDateString('fr-FR', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
        }

    },
    created() {
        this.anneeRoute = this.$route.params.annee;
        this.onSearch()
        this.getExercices()
        this.$http.get('/typologiePta')
            .then(({ data }) => {
                console.log(data);
                console.log(1);
                this.typologies = data;
            });


    },
}
</script>

<style></style>